import { clearStorageAtom } from '@/store/root'
import { LoadingOutlined, LogoutOutlined } from '@ant-design/icons'
import LoadingBox from '@c/loading/loading-box'
import { postSysLoginout } from '@s/login'

const Logout = () => {
  const clearStorage = useSetAtom(clearStorageAtom)

  const { mutate, isPending } = useMutation({
    mutationFn: postSysLoginout,
    onSuccess: res => {
      if (isValidRes(res)) {
        queryClient.clear()
        clearStorage()
      }
    },
  })

  return (
    <LoadingBox indicator={<LoadingOutlined />} loading={isPending} type="wrap">
      <div className="fcc cursor-pointer gap-2 hover:text-main" onClick={() => mutate()}>
        <LogoutOutlined />
        退出登录
      </div>
    </LoadingBox>
  )
}
export default Logout
